export enum StaffTableColumns {
  NameFullLocal = "nameFullLocal",
  PersonId = "personId",
  ExternalId = "externalId",
  PersonExternalId = "personExternalId",
  Role = "role",
  Gender = "gender",
  Status = "status",
  Nationality = "nationality",
  DateOfBirth = "dateOfBirth",
}
